/*!
 * Copyright (c) 2018, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

<template>
  <div>
      <div id="home" class="container-lg mt-4">
        <div v-if="!getIsAuthenticated">
          <h1 class="ui header"></h1>
          <router-link
            id="login-button"
            class="btn btn-lg formSubmit"
            role="button"
            to="/login"
          >
            Login
          </router-link>
        </div>

        <div v-if="getIsAuthenticated">
          <h1 class="ui header">Welcome back, {{userValues.name}}!</h1>
          <p>You can visit the <router-link to="/capability" >Capability </router-link> page to see your capability assessment.</p>
        </div>
      </div>

      <!-- Loading screen start -->
      <div :class="isLoadingScreen()">
          <loadingComponent :msg="getLoadingText" />
      </div>
      <!-- Loading screen end -->
  </div>
</template>

<style scoped lang="scss">
    h1,h2,h3,h4,h5,h6, p, .ui.header {
        color: $darkgrey !important;
    }
    
    a {
        color: $darkgrey !important;
        font-weight: bold;
    }
</style>

<script>
  import loadingComponent from '@/components/capabilityParts/loading.vue'
  import _successionControllerAPI from '@/mixins/_successionControllerAPI'
  import _successionControllerLocalAPI from '@/mixins/_successionControllerLocalAPI'
  import { mapGetters } from 'vuex';


  export default {
    name: 'home',
    mixins: [_successionControllerAPI, _successionControllerLocalAPI],
    data: function () {
      return {
        claims: '',
        accessToken: '',

        uiLoadingScreen: false,
        uiLoadingText: '',

        userValues: {}
      }
    },
    mounted () { 
      this.setup()
    },
    computed: {
        ...mapGetters([
            'getIsAuthenticated'
        ]), 
        getLoadingText() {
            return this.uiLoadingText;
        },
    },
    methods: {
      loadingOverlayStart(text, isFullScreenLoading, delay) {
          let self = this;

          if(!isFullScreenLoading) {
              self.$emit('navLoadingStart');
          } else {
              self.uiLoadingScreen = true;
              self.uiLoadingText = text
          }

          if(delay != null) {
              setTimeout(function() {
                  self.loadingOverlayStop(isFullScreenLoading);
              }, Number(delay));
          }
      },
      loadingOverlayStop(isFullScreenLoading) {
          let self = this;
          
          if(!isFullScreenLoading) {
              self.$emit('navLoadingStop');
          } else {
              self.uiLoadingScreen = false;
              self.uiLoadingText = ''
          }
      },
      isLoadingScreen() {
          var self = this;
          let classes = self.uiLoadingScreen ? 'fadeIn anim-035' : 'd-none';

          return classes;
      },
      async setup () {
        let self = this;

        self.loadingOverlayStart('Loading, <br/> please wait.', true);

        if (this.getIsAuthenticated) {
            self.accessToken = localStorage.getItem("access_token");
            // self.claims = await Object.entries(await this.$auth.getUser()).map(entry => ({ claim: entry[0], value: entry[1] }));

            self.getUser(self.accessToken, (user)=> {
                let name = user.name,
                email = user.email;

                self.userValues = user;

                self.userData.user.name = name;
                self.userData.user.email = email;

                console.log('homepage for...' , email);
                self.loadingOverlayStop(true);

                if(email != null) {
                  self.loadingOverlayStart('Loading, <br/> please wait.', true);

                  self.login(self.accessToken, email).then((response) => {
                      self.loadingOverlayStop(true);

                      if(response.data != null && response.data != '') {
                          self.userData.user = response.data;
                          self.userValues = response.data;
                      }
                  }).catch((err) => {
                      console.log("ERR", err);
                      self.loadingOverlayStart('Failure to load user data.', true, 10000);
                  });

                }

            });

        } else { 
            self.$router.push('login');
        }

      }
    },
    components: {
        loadingComponent
    },

  }
</script>

